export const LOGIN 			     	= "LOGIN";
export const UPDATE_UTENTE_LOGIN 	= 'UPDATE_UTENTE_LOGIN';
export const UPDATE_UTENTE_PASSWORD = 'UPDATE_UTENTE_PASSWORD';